import AdminUser from "@icons/admin-user.svg?react";
import ArrowAltToRight from "@icons/arrow-alt-to-right.svg?react";
import { Trans } from "@lingui/react/macro";
import { Link, NavLink } from "react-router-dom";

import { AdminGuard } from "@/common/acl/guard/guard";
import { Logo } from "@/common/components/logo/logo";
import { useToggle } from "@/common/hooks/use-toggle";
import { useCompany } from "@/common/providers/company-provider";
import { useFeatureProvider } from "@/common/providers/feature-provider";

import { NavBar } from "../nav-bar/nav-bar";
import { getClassName } from "../nav-bar/nav-bar.utils";
import { Spacer } from "../spacer/spacer";

const SideBar = () => {
  const expanded = useToggle();
  const { company } = useCompany();
  const features = useFeatureProvider();

  return (
    <div
      className={`fixed top-0 hidden h-screen ${expanded.on ? "z-100 w-[249px] [&>a]:-ml-[177px]" : "w-[72px]"} flex-col items-center sm:flex`}
    >
      <Logo />
      <div className={`bg-can-forest-teal flex w-full grow flex-col`}>
        <Spacer className="h-0.5 w-full bg-white" />
        <Spacer className="h-8" />
        <NavBar
          plan={{
            features,
            planId:
              company?.plan.id ?? Object.values(features)[0]?.planId ?? null,
            type: company?.plan.type ?? "BASIC",
          }}
          renderItem={
            expanded.on
              ? (link, Wrapper) => (
                  <NavLink
                    className={({ isActive }) =>
                      `relative justify-start! self-start ${itemClassName} [&_svg]:shrink-0 ${getClassName({ isActive })}`
                    }
                    key={link.to}
                    to={link.to}
                  >
                    <Wrapper>{link.icon}</Wrapper>
                    {link.label}
                  </NavLink>
                )
              : undefined
          }
        />
        <AdminGuard>
          <Link
            className={`${itemClassName} ${getClassName({ isActive: false })} ${expanded.on ? "justify-start!" : ""}`}
            target="_blank"
            to="/admin"
          >
            <AdminUser />
          </Link>
        </AdminGuard>
        <button
          className={`mb-8 w-full ${itemClassName} self-center font-bold text-[#85C4B3]`}
          onClick={expanded.toggle}
        >
          <ArrowAltToRight className={expanded.on ? "rotate-180" : ""} />
          {expanded.on ? (
            <span>
              <Trans>Zobrazit jen ikony</Trans>
            </span>
          ) : null}
        </button>
      </div>
    </div>
  );
};

const itemClassName = "gap-4 px-6 flex";

export { SideBar };
